export default __webpack_public_path__ + "static/media/cloud.ae34889c.svg";